import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-privacy-policy-mbl',
    templateUrl: './privacy-policy-mbl.component.html',
    styleUrls: ['./privacy-policy-mbl.component.css', './../landing/landing.component.css', '../security/security.component.css'],
    standalone: false
})
export class PrivacyPolicyMblComponent {
  constructor(
    private modalService: NgbModal
  ) {}
  onClose() {
    this.modalService.dismissAll();
  }
}
